module.exports = __webpack_public_path__ + "img/name-request-report.dd43858a.jpg";